// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3zrfP","question":"Question_question__2E41f","description":"Question_description__JiE3s"};